import * as React from "react";
import Metatags from "@ADC/components/Metatags";
import {
  Header,
  Home,
  // NewForm,
  AsSeenOn,
  // ResolveDebt,
  Apply,
  Faqs,
  Footer,
} from "@ADC/components/Pages/ServiceAreasLanders";
import NotFoundPage from "@ADC/pages/404";
import { HighIncome } from "@ADC/components/Views";
import { trackingCodes } from "@ADC/data";

const IndividualCityPage = (props) => {
  const {
    serverData: { data },
  } = props;
  const {
    phoneNumber,
    heroSectionImage,
    heroSectionVideo,
    cityProsBadge,
    address,
    name,
  } = data?.attributes || {};

  return (
    <React.Fragment>
      {!data ? (
        <NotFoundPage />
      ) : (
        <React.Fragment>
          <Header phoneNumber={phoneNumber} />
          <Home
            name={name}
            cityProsBadge={cityProsBadge}
            heroSectionImage={heroSectionImage}
            heroSectionVideo={heroSectionVideo}
          />
          <HighIncome phoneNumber={phoneNumber} />
          <AsSeenOn />
          <Faqs />
          <Apply />
          <Footer address={address} />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default IndividualCityPage;

export const Head = ({ serverData: { data } }) => {
  return (
    <>
      <Metatags
        pageTitle={data?.attributes?.metaTitle}
        metaTitle={data?.attributes?.metaTitle}
        description={data?.attributes?.metaDescription}
        imageUrl={data?.attributes?.metaImage?.data?.attributes?.url}
        datePublished={data?.attributes?.publishedAt}
        dateModified={data?.attributes?.updatedAt}
        type="article"
      />
      {data?.attributes?.path === "/wfaa-r/" && (
        <script
          dangerouslySetInnerHTML={{
            __html: `!function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${trackingCodes.wfaaMetaPixel}');
            fbq('track', 'PageView');`,
          }}
        />
      )}
    </>
  );
};

export async function getServerData({ params: { slug } }) {
  try {
    const res = await fetch(
      `${process.env.ADC_API_URL}/adc-ragular-landers?populate=*&sort=id:asc&filters[path][$eq]=/${slug}/`
    );

    if (!res.ok) {
      throw new Error(`Response failed`);
    }
    const data = await res.json();

    if (data?.data?.length) {
      return {
        props: { data: data?.data[0] },
      };
    } else {
      return {
        props: { data: null },
      };
    }
  } catch (error) {
    return {
      status: 500,
      headers: {},
      props: {},
    };
  }
}
